export default "__VITE_PUBLIC_ASSET__cfde9746__"